import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { Document } from "../../models/Document";

export const DocumentApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "documentApi",
  tagTypes: ['Document'],

  endpoints(build) {
    return {
      uploadDocument: build.mutation<any, Document>({
        query: (data) => {
          const formData = new FormData();
          data.files.forEach((file: File) => {
            formData.append("files", file); 
          });

          return {
            url: `project/${data.projectId}/milestone/${data.milestoneId}/upload-files`,
            method: "POST",
            data: formData, 
            headers: {
              "Content-Type": "multipart/form-data", 
            },
          };
        },
        invalidatesTags: ['Document'],
      }),

      getDocuments: build.mutation<any, {projectId: number, milestoneId: number}>({
        query: ({projectId, milestoneId}) => {
          return {
            url: `project/${projectId}/milestone/${milestoneId}/files`,
            method: "GET",
            params: {projectId, milestoneId}
          }
        }
      }),

      downloadFile: build.mutation<any, {filePath: string, fileName: string}>({
        query: ({filePath, fileName}) => {
          return {
            url: `project/file`,
            method: "GET",
            params: {filePath, fileName},
            responseHandler: (response : any) => response.blob(),
            // responseType: 'blob',
          }
        }
      })

    };
  },
});

export const { useUploadDocumentMutation, useGetDocumentsMutation, useDownloadFileMutation } = DocumentApi;
